// extracted by mini-css-extract-plugin
module.exports = {"form":"_3Q4ux3Rjs5bpWD7p9J2zhb","column":"wbgDOrLmMpi8aMHbSu01W","label-margin":"_3hU-bVRWF3uw5jjf44IeJh"};